module.exports = __webpack_public_path__ + "/images/mockup_lista_general_IT.c559546.png";